export const LOGIN = 'login';
export const FORGOT_PASSWORD = 'forgot-password';
export const CONFIRMATION = 'confirmation';
export const PASSWORD_RESET = 'password-reset';
export const STATUS_OK = "ok";
export const STATUS_ERROR = "error";
export const MFA_CODE_SUBMISSION = "mfa-response";
